import { makeActionCreator } from '../../utils/actionsUtils';
import { SHOW_SUB_NAV, HIDE_SUB_NAV } from './constants';

// show a specific sub nav
export const showSubNav = makeActionCreator(SHOW_SUB_NAV, 'subNav');

// hide the sub nav
export const hideSubNav = makeActionCreator(HIDE_SUB_NAV);



// WEBPACK FOOTER //
// ./src/services/nav/actions.js